/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Col_CreatorInputs */

const vi_stocktake_col_creator = /** @type {(inputs: Stocktake_Col_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người tạo`)
};

/**

* @param {Stocktake_Col_CreatorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_col_creator = /** @type {((inputs?: Stocktake_Col_CreatorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Col_CreatorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_col_creator(inputs)
});